import React from 'react';
import { Typography } from "antd";

const { Title } = Typography;

type Props = {
  onChange: any;
  value: string;
}

export const SPTitle: React.FC<Props> = (props) => {
  return (
    <Title {...props}>
      {props.value}
    </Title>
  );
};